import { useEffect, useState } from "react";
import { _EmployeeContract, _EmployeeContractHistory, _single } from "../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { Singleton } from "../../../../core/services/Singleton";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { BasicButton } from "../../../theme/Component/BasicButton";
import { BasicTable, MASK_DATE, MASK_MONEY, MASK_NUMBER, MASK_TEXT_NOWRAP } from "../../../theme/Component/BasicTable";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { Modal } from "../../../theme/Component/Modal";
import useModal, { MODAL_md, MODAL_SM } from "../../../theme/Component/hooks/useModal";
import { toast } from "react-toastify";
import { EditEmployeeContract } from "./EditEmployeeContract";

export const EmployeeContractByEdit = () => {


    const _employeeContract = useDataBean(_EmployeeContract);
    const { instance, handleChange, bean, setBean, lista, setLista } = _employeeContract;
    const single = Singleton.getInstance();


    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });

    const [form, setForm] = useState<any>({
        IDContract: undefined,
    })

    const modalDelete = useModal(`¿Esta seguro que desea eliminar el contrato ${bean.IDContract}?`, MODAL_md, { headerClass: "bg-warning text-dark", buttonClass: "btn-danger" });

    const getLista = () => {
       
        instance.getEmployeeContractHistoryByIDContract(form.IDContract).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp);
                }
            }
        ).catch(err => { toast.error(err) })
    }

    const update = () => {
        let x = bean;
        x.IDEmployeeLastUpdate = single.getAccountID()
        instance.updateCustonBean(x).then(
            (resp) => {
                single.update(bean)
                getLista();
                setBean({});
                setModal({ ...modal, "view": false });
            }
        )
    }



    const listaBotones = () => {
        const botones = [
            // { titulo: 'Editar Contrato', icono: 'ri-edit-2-line', visible: true, evento: () => { setModal({ ...modal, "name": "Editar Contrato Laboral", "view": true }) } },
            { titulo: 'Eliminar Contrato de Trabajo', icono: 'ri-delete-bin-line', visible: _single.canDelete(), evento: () => { modalDelete.open() } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    const taps = [
        { id: 0, name: 'Información Contrato' },
        { id: 1, name: 'Información interna' },
        { id: 2, name: 'Seguridad Social y Aportes' },
        { id: 3, name: 'Retención en la Fuente' },
    ]

    const [indexTap, setIndexTap] = useState(0);

    const deleteContract = () => {
        instance.removeEmployeContract(_single.getAccountID(), bean.IDContract).then(
            (resp) => {
                getLista();
                modalDelete.close();
            }
        ).catch(err => {
            toast.error(err)
        })
    }

    const head = [
        { title: 'IDContrato', property: 'IDContract', visible: true },
        { title: 'Empleado', property: 'AccountName', visible: true },
        { title: 'Tipo de Contrato', property: 'ContractTypeName', visible: true },
        { title: 'Nivel Jerárquico', property: 'EntailmentName', visible: true },
        { title: 'Nivel Salarial/Grado', property: 'AppointmentName', visible: true },
        { title: 'Tipo Vinculación', property: 'EmployeeContractType', visible: true },
        { title: 'Plaza Laboral', property: 'IDLnFunctionalArea', mask: MASK_NUMBER, visible: true },
        { title: 'Fecha de Inicio', property: "InitDate", mask: MASK_DATE, visible: true },
        { title: 'Ultima Actualización', property: 'LastUpdate', visible: true },
    ]

    return (
        <>
            <BasicPage titulo="Buscar / Editar Contrato">
                <div className="row">
                    <div className="col-12">
                        <div className="row">
                            <div className="col-md-7">
                                <label>ID Contrato</label>
                                <input type="text" name="IDContract" className="form-control" value={form.IDContract} onChange={(e) => { setForm({ ...form, "IDContract": e.target.value }) }} />
                            </div>
                            <div className="col-md-5 mt-4 p-2">
                                <BasicButton eventClick={getLista} icon="ri-search-line" children={"Buscar"} />
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-12">
                        <BasicTable
                            listButtons={listaBotones()}
                            head={head} body={lista}
                            rowSet={setBean}
                        />
                    </div>
                </div>

            </BasicPage>

            <Modal modal={modalDelete.modal} updateModal={modalDelete.setModal} onSubmitLabel="Confirmar" eventModal={() => { deleteContract() }} >
                <span className="text-center">
                    <p className="text-danger" >Esta acción no es <b>Reversible</b> <br /></p>
                    <p>¿Desea continuar?</p>
                </span>
            </Modal>


            <Modal modal={modal} updateModal={setModal} eventModal={() => { update() }} >
                <EditEmployeeContract bean={bean} setBean={setBean} />
            </Modal>

        </>
    )
}